import { Api, ArrayUtil, ExternalLink } from "@mcleod/core";

export class IdeasPortalLink extends ExternalLink {
    constructor() {
        super("McLeod Ideas Portal", null);
    }

    protected override async resolveURL(): Promise<void> {
        const response = await Api.post("lme/general/ideas-portal-url");
        const data = ArrayUtil.getFirstElement(response?.data);
        this.url = data?.url;
    }

    public override async open(): Promise<boolean> {
        const result = await super.open();
        //the token in the url isn't valid for very long, so throw it out
        this.url = null;
        return result;
    }
}
